<template>
	<div>
		<el-card class="searchItemFlex">
			<span>角色名称：</span>
			<el-input
				v-model="queryParam.roleName"
				style="width: 160px"
				placeholder="角色名称"
				clearable
				size="mini"></el-input>
			<span>状态：</span>
			<el-radio-group size="mini" v-model="queryParam.status">
				<el-radio-button :label="0">正常</el-radio-button>
				<el-radio-button :label="1">禁用</el-radio-button>
				<el-radio-button :label="2">全部</el-radio-button>
			</el-radio-group>
			<el-button type="primary" size="mini" @click="getRoleList"
				><i class="el-icon-search"></i>&nbsp;查询</el-button
			>
			<el-button type="warning" size="mini" @click="reset"
				><i class="el-icon-refresh"></i>&nbsp;重置</el-button
			>
			<el-button type="success" size="mini" @click="changeVisible(true)" class="right"
				><i class="el-icon-plus"></i>&nbsp;添加角色</el-button
			>
			</el-card>
			<el-card>
			<el-table
				ref="RoleTable"
				:data="rolesItemList"
				size="mini"
				border
				height="610"
				style="width: 100%"
				v-loading="roleLoading"
				@sort-change="SortChange"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(255, 255, 255, 0.8)">
				<el-table-column
					label="编号"
					prop="role.roleId"
					:sortable="'custom'"
					width="90"></el-table-column>
				<el-table-column
					label="角色名称"
					width="140"
					prop="role.roleName"
					show-overflow-tooltip></el-table-column>
				<el-table-column
					label="角色描述"
					width="360"
					prop="role.description"
					show-overflow-tooltip></el-table-column>
				<el-table-column label="角色权限" width="120">
					<template slot-scope="scope">
						<el-popover placement="top" width="500" trigger="click">
							<el-table
								size="mini"
								border
								:data="scope.row.rightList"
								height="500">
								<el-table-column type="index" width="50"></el-table-column>
								<el-table-column
									width="130"
									property="rightName"
									label="权限名称"
									show-overflow-tooltip></el-table-column>
								<el-table-column
									width="300"
									property="notes"
									label="权限描述"
									show-overflow-tooltip></el-table-column>
							</el-table>
							<el-button slot="reference" size="mini" type="primary" plain
								>点击查看</el-button
							>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column
					label="创建时间"
					width="160"
					:sortable="'custom'"
					prop="role.createTime">
					<template slot-scope="scope">
						<el-tag type="info" size="mini">{{
							scope.row.role.createTime | dateformatAll("YYYY-MM-DD HH:mm:ss")
						}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="角色状态" width="100">
					<template slot-scope="scope">
						<el-tag
							type="success"
							size="mini"
							v-if="scope.row.role.status === 0"
							>正常</el-tag
						>
						<el-tag type="danger" size="mini" v-else>禁用</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button
							type="danger"
							size="mini"
							v-show="scope.row.role.roleId !== 1"
							v-if="scope.row.role.status === 0"
							@click="changeStatus(scope.row.role.roleId, 1)"
							>禁用</el-button
						>
						<el-button
							type="success"
							size="mini"
							v-show="scope.row.role.roleId !== 1"
							v-else
							@click="changeStatus(scope.row.role.roleId, 0)"
							>启用</el-button
						>
						<el-button
							type="warning"
							size="mini"
							v-show="scope.row.role.roleId !== 1"
							@click="openModifyDialog(scope.row)"
							>修改</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<!--分页部分-->
			<el-pagination
				background
				@size-change="pagesizeChange"
				@current-change="pagenumChange"
				:current-page="queryParam.pageNum"
				:page-sizes="[10, 50, 100, 200, 500]"
				:page-size="queryParam.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				style="margin-top: 10px">
			</el-pagination>
		</el-card>
		<new-role
			:newRoleVisible="newRoleVisible"
			:flushRoleList="getRoleList"
			:rightList="rightList"
			@changeVisible="changeVisible"></new-role>
		<change-role
			:RoleFormCp="changeRoleForm"
			:changeRoleVisible="changeRoleVisible"
			:flushRoleList="getRoleList"
			:rightList="rightList"
			@changeVisible="changeModifyVisible"></change-role>
	</div>
</template>
<script>
import ChangeRole from "../../components/role/ChangeRole.vue"
import NewRole from "../../components/role/NewRole.vue"

export default {
	name: "roleManage",
	components: { NewRole, ChangeRole },
	data() {
		return {
			queryParam: {
				roleName: "",
				status: 2,
				pageNum: 1,
				pageSize: 50,
				order: 0,
			},
			rolesItemList: [],
			total: 0,
			roleLoading: false,
			newRoleVisible: false,
			rightList: [],

			changeRoleVisible: false,
			changeRoleForm: {
				role: {},
				rightList: [],
			},
		}
	},
	mounted() {
		this.getRightList()
		this.getRoleList()
	},
	methods: {
		//获取所有权限列表
		async getRightList() {
			const { data: res } = await this.$http.post("right/rightList").catch(err => err)
			if (res) {
				this.rightList = res
			}
		},
		changeVisible(val) {
			this.newRoleVisible = val
		},
		changeModifyVisible(val) {
			this.changeRoleVisible = val
		},
		async getRoleList() {
			this.roleLoading = true
			const { data: res } = await this.$http.post("role/list", this.queryParam).catch(err => err)
			if (res) {
				this.rolesItemList = res.rolesItemList
				this.total = res.total
			}
			this.roleLoading = false
		},
		reset() {
			this.queryParam = {
				roleName: "",
				status: 2,
				pageNum: 1,
				pageSize: 50,
				order: 0,
			}
			this.$refs.RoleTable.columns.forEach(item => {
				item.order = ""
			})
			this.getRoleList()
		},
		SortChange(column) {
			if (column.prop == "role.roleId") {
				if (column.order == "ascending" || column.order == null) {
					this.queryParam.order = 0
				} else {
					this.queryParam.order = 1
				}
			} else if (column.prop == "role.createTime") {
				if (column.order == "ascending" || column.order == null) {
					this.queryParam.order = 3
				} else {
					this.queryParam.order = 2
				}
			} else {
				this.queryParam.order = 0
			}
			this.getRoleList()
		},
		pagesizeChange(newSize) {
			this.queryParam.pageSize = newSize
			this.queryParam.pageNum = 1
			this.getRoleList()
		},
		pagenumChange(newNum) {
			this.queryParam.pageNum = newNum
			this.getRoleList()
		},
		async changeStatus(id, status) {
			var text = status === 0 ? "启用" : "禁用"
			const confirmresult = await this.$confirm(
				"将要" +
					text +
					"该角色，该操作会影响拥有此角色的用户的权限，请确定是否继续？",
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}
			).catch(err => err)
			if (confirmresult !== "confirm") {
				return this.$message.info("操作已取消")
			}
			const { data: res } = await this.$http.post("role/status", {
				id: id,
				status: status,
			}).catch(err => err)
			if (res) {
				this.$message.success("操作成功！")
				this.getRoleList()
			}
		},
		openModifyDialog(row) {
			var str = JSON.stringify(row)
			var fm = JSON.parse(str)
			var rightList = fm.rightList
			var rightIdList = []
			for (var i = 0; i < rightList.length; i++) {
				rightIdList.push(rightList[i].rightId)
			}
			this.changeRoleForm = {
				role: fm.role,
				rightList: rightIdList,
			}
			this.changeModifyVisible(true)
		},
	},
}
</script>
<style scope></style>
